module.exports = __webpack_public_path__ + "img/armholecurve.6cb28c36.png";